export class BasementType {
  static NONE = "0";
  static HEATED = "1";
  static UNHEATED = "2";
}
